import { render, staticRenderFns } from "./exhibitiondetails.vue?vue&type=template&id=954dee86&scoped=true&"
import script from "./exhibitiondetails.vue?vue&type=script&lang=js&"
export * from "./exhibitiondetails.vue?vue&type=script&lang=js&"
import style0 from "./exhibitiondetails.vue?vue&type=style&index=0&id=954dee86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954dee86",
  null
  
)

export default component.exports